import { render } from "./InspecList.vue?vue&type=template&id=7b628504"
import script from "./InspecList.vue?vue&type=script&lang=js"
export * from "./InspecList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__